/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * PaymentLinkModal
 *
 */

import React, { memo, useRef, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { ConfirmModal, Conditional } from '@cashfree-intl/coherent';
import useClickOutside from 'utils/hooks';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { MerchantContext } from 'contexts/MerchantContext';
import VendorDetailsForm from './components/VendorDetailsForm';
import KycForm from './components/KycForm';
import { BUSINESS } from '../../constants';
import KycFormV2 from './components/KycFormV2';

function EasySplitModalV2({
  open,
  closeModal,
  isEditMode,
  submitVendorModal,
  editModalLoading,
  modalErr,
  submitKycModal,
  handleVendorDetailsPayload,
  handleKycDataPayload,
  downloadDoc,
  vendorId,
  isMerchantCritical,
  businessRelatedInfo = {},
  data = {},
  scheduleOptions = {},
  kycData = {},
  vendorStatus,
  detailsPageClicked = false,
  detailsPageStep,
  passVendorDetails,
  vendorDocs,
  submitVendorDocuments,
  initialStep,
  verifyPan,
  verifyCin,
  verifyGst,
  incrementalVendorOnboarding = false,
  createOnboardingUser,
  submitVendorDetails,
  saveAndExitKycForm,
  userInfo = {},
  vendorOnboardingDetails,
}) {
  const { isVpaEnabled } = useContext(MerchantContext);

  const [step, setStep] = useState(1);
  const [updatedPayload, setUpdatedPayload] = useState({});
  const [vendorFormData, setVendorFormData] = useState();
  const [kycFormData, setKycFormData] = useState();
  const [accountType, setAccountType] = useState(BUSINESS);
  const [addressProof, setAddressProof] = useState();
  const [fileValidationErrors, setFileValidationErrors] = useState({});
  const [active, setActive] = useState(false);
  const [isKycDataFilled, setIsKycDataFilled] = useState(false);
  const [vendorCreated, setVendorCreated] = useState(false);
  const [, setTempValues] = useLocalStorage('vendorFormData');
  const [, setKycTempValues] = useLocalStorage('vendorKycFormData');

  const modalRef = useRef(null);

  useClickOutside(modalRef, closeModal);

  let updatedData = { ...data };

  if (!incrementalVendorOnboarding) {
    updatedData = { ...data, ...kycData, ...businessRelatedInfo };
  }
  delete updatedData.status;

  useEffect(() => {
    if (detailsPageStep) setStep(detailsPageStep);
  }, []);

  useEffect(() => {
    if (initialStep) setStep(initialStep);
  }, [initialStep]);

  return (
    <div>
      <Conditional if={step === 0 && !isEditMode}>
        <ConfirmModal
          danger
          title="Cancel Adding Vendor"
          confirmText="Yes, Cancel"
          cancelText="Keep editing"
          onClose={() => setStep(1)}
          onConfirm={() => {
            setTempValues({});
            setKycTempValues({});
            closeModal();
          }}
          confirmBtnEvent="Danger_Button_Cancel_Adding_Vendor_Confirm"
          closeBtnEvent="Link_Button_Cancel_Adding_Vendor_Cancel"
          closeCrossEvent="Cancel_Adding_Vendor_Icon_Close"
        >
          Are you sure you want to cancel adding the vendor? By clicking Cancel,
          all changes will be lost.
        </ConfirmModal>
      </Conditional>
      <Conditional if={step === 0 && isEditMode}>
        <ConfirmModal
          danger
          title="Cancel Updating details"
          confirmText="Yes, Cancel"
          cancelText="Keep editing"
          onClose={() => setStep(1)}
          onConfirm={closeModal}
          confirmBtnEvent="Danger_Button_Cancel_Updating_Details_Confirm"
          closeBtnEvent="Link_Button_Cancel_Updating_Details_Cancel"
          closeCrossEvent="Cancel_Updating_Details_Icon_Close"
          closeBtnProperties={JSON.stringify({ step })}
          confirmBtnProperties={JSON.stringify({ step })}
        >
          Are you sure you want to cancel updating the vendor? By clicking
          Cancel, all changes will be lost.
        </ConfirmModal>
      </Conditional>
      <Conditional if={step === 1 || step === 2}>
        <VendorDetailsForm
          open={open}
          isEditMode={isEditMode}
          closeModal={closeModal}
          submitVendorModal={submitVendorModal}
          scheduleOptions={scheduleOptions}
          data={updatedData}
          modalErr={modalErr}
          step={step}
          setStep={setStep}
          editModalLoading={editModalLoading}
          updatedPayload={updatedPayload}
          setUpdatedPayload={setUpdatedPayload}
          handleVendorDetailsPayload={handleVendorDetailsPayload}
          vendorFormData={vendorFormData}
          setVendorFormData={setVendorFormData}
          vendorStatus={vendorStatus}
          vpaEnabled={isVpaEnabled}
          active={active}
          setActive={setActive}
          isKycDataFilled={isKycDataFilled}
          detailsPageClicked={detailsPageClicked}
          passVendorDetails={passVendorDetails}
          incrementalVendorOnboarding={incrementalVendorOnboarding}
          createOnboardingUser={createOnboardingUser}
          submitVendorDetails={submitVendorDetails}
          vendorCreated={vendorCreated}
          vendorDocs={vendorDocs}
        />
      </Conditional>
      <Conditional if={step === 3 && !incrementalVendorOnboarding}>
        <KycForm
          open={open}
          isEditMode={isEditMode}
          closeModal={closeModal}
          submitKycModal={submitKycModal}
          scheduleOptions={scheduleOptions}
          submitVendorModal={submitVendorModal}
          data={updatedData}
          modalErr={modalErr}
          step={step}
          setStep={setStep}
          editModalLoading={editModalLoading}
          updatedPayload={updatedPayload}
          setUpdatedPayload={setUpdatedPayload}
          handleKycDataPayload={handleKycDataPayload}
          downloadDoc={downloadDoc}
          merchantVendorId={vendorId}
          businessRelatedInfo={businessRelatedInfo}
          kycFormData={kycFormData}
          setKycFormData={setKycFormData}
          accountType={accountType}
          setAccountType={setAccountType}
          addressProof={addressProof}
          setAddressProof={setAddressProof}
          fileValidationErrors={fileValidationErrors}
          setFileValidationErrors={setFileValidationErrors}
          isMerchantCritical={isMerchantCritical}
          setIsKycDataFilled={setIsKycDataFilled}
          detailsPageClicked={detailsPageClicked}
        />
      </Conditional>
      <Conditional
        if={
          step === 3 &&
          incrementalVendorOnboarding &&
          vendorDocs?.documents?.length
        }
      >
        <KycFormV2
          open={open}
          step={step}
          vendorDocs={vendorDocs}
          submitVendorDocuments={submitVendorDocuments}
          isEditMode={isEditMode}
          verifyPan={verifyPan}
          verifyCin={verifyCin}
          verifyGst={verifyGst}
          closeModal={closeModal}
          saveAndExitKycForm={saveAndExitKycForm}
          userInfo={userInfo}
          setStep={setStep}
          vendorCreated={vendorCreated}
          setVendorCreated={setVendorCreated}
          downloadDoc={downloadDoc}
          merchantVendorId={vendorId}
          vendorOnboardingDetails={vendorOnboardingDetails}
          vendorFormData={vendorFormData}
          setVendorFormData={setVendorFormData}
        />
        {/* <div>alkdfdlkfkldsfkldlkfj</div> */}
      </Conditional>
    </div>
  );
}

EasySplitModalV2.propTypes = {
  open: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  submitVendorModal: PropTypes.func,
  scheduleOptions: PropTypes.object.isRequired,
  editModalLoading: PropTypes.bool,
  modalErr: PropTypes.any,
  submitKycModal: PropTypes.func,
  handleVendorDetailsPayload: PropTypes.func.isRequired,
  handleKycDataPayload: PropTypes.func.isRequired,
  downloadDoc: PropTypes.func,
  kycData: PropTypes.object,
  vendorId: PropTypes.string.isRequired,
  businessRelatedInfo: PropTypes.object.isRequired,
  isMerchantCritical: PropTypes.bool.isRequired,
  vendorStatus: PropTypes.string.isRequired,
  detailsPageClicked: PropTypes.bool,
  detailsPageStep: PropTypes.bool,
  passVendorDetails: PropTypes.func,
  vendorDocs: PropTypes.object,
  submitVendorDocuments: PropTypes.func,
  initialStep: PropTypes.number,
  verifyPan: PropTypes.func,
  verifyCin: PropTypes.func,
  verifyGst: PropTypes.func,
  incrementalVendorOnboarding: PropTypes.bool,
  createOnboardingUser: PropTypes.func,
  submitVendorDetails: PropTypes.func,
  saveAndExitKycForm: PropTypes.func,
  userInfo: PropTypes.object,
  vendorOnboardingDetails: PropTypes.object,
};

export default memo(EasySplitModalV2);
